import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EConsultationRequestActions } from '../../constants/actionTypes/consultationRequest';

export const setModalOpen = actionGenerator<EConsultationRequestActions.SetModalOpen, boolean>(
  EConsultationRequestActions.SetModalOpen,
);
export type TSetModalOpenAction = ReturnType<typeof setModalOpen>;

export type TConsultationRequestActions = TSetModalOpenAction;
